'use strict';Object.defineProperty(exports,'__esModule',{value:true});var _reactRedux=require('react-redux');var _component=require('./component');var _component2=_interopRequireDefault(_component);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}exports.default=(0,_reactRedux.connect)(function(state){return{lang:state.i18nState.lang,translations_reducer:state.i18nState.translations,forceRefresh:state.i18nState.forceRefresh}})(_component2.default);


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-i18n/dist/component/index.js
// module id = 478
// module chunks = 0